import styled from "styled-components";

export const TodayTotalDiv = styled.div`
  position: relative;
  border-radius: 8px;
  color: #2b3445;
  display: flex;
  flex-direction: column;
  font-size: 14px;
  justify-content: center;
  line-height: 21px;
  @media (max-width: 768px) {
  }
`;
export const TodayText = styled.h5`
  color: #4187e8;
  font-weight: 600;
  font-size: 20px;
  margin: 0px 0px 4px;
`;
export const TotalCount = styled.h3`
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  margin: 24px 0px 0px;
`;
export const TotalCountText = styled.p`
  color: #ffffff;
  font-size: 14px;
  line-height: 24.5px;
`;
export const DashboardImageDiv = styled.div`
  @media (max-width: 768px) {
  }
`;
